import { render, staticRenderFns } from "./InpatientReviewFooter.vue?vue&type=template&id=9a608b16&scoped=true&"
import script from "./InpatientReviewFooter.vue?vue&type=script&lang=js&"
export * from "./InpatientReviewFooter.vue?vue&type=script&lang=js&"
import style0 from "./InpatientReviewFooter.vue?vue&type=style&index=0&id=9a608b16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a608b16",
  null
  
)

export default component.exports